(() => {
  'use strict';
  if (window.GrowplayReviewCarousel) return;
  const controllers = new Map();

  function init(scope = document) {
    scope.querySelectorAll('[data-gp-review-carousel]').forEach(host => {
      if (controllers.has(host)) return;
      const template = host.querySelector('[data-gp-review-carousel-template]');
      if (!template) return;
      const fallback = host.querySelector('[data-gp-review-carousel-fallback]');
      let mounted = false;
      let timer;
      let attempts = 0;
      let previousApi;
      const finish = () => {
        const carousel = host.querySelector('#klaviyo-reviews-carousel-wrapper');
        if (!carousel?.querySelector('.swiper-slide')) return false;
        host.setAttribute('aria-busy', 'false');
        if (fallback) fallback.hidden = true;
        clearTimeout(timer);
        mutations.disconnect();
        return true;
      };
      const render = () => {
        if (finish() || !host.isConnected) return;
        const api = window.klReviewsObject;
        if (api && typeof api.renderWidgets === 'function' && api !== previousApi) {
          previousApi = api;
          api.renderWidgets();
        }
        if (++attempts < 30 && !finish()) timer = setTimeout(render, 500);
        else if (attempts >= 30) host.setAttribute('aria-busy', 'false');
      };
      const mount = () => {
        if (mounted) return;
        mounted = true;
        visibility.disconnect();
        mutations.observe(host, {childList: true, subtree: true});
        host.append(template.content.cloneNode(true));
        template.remove();
        render();
      };
      const mutations = new MutationObserver(finish);
      const visibility = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) mount();
      }, {rootMargin: '600px 0px'});
      visibility.observe(host);
      controllers.set(host, () => {
        clearTimeout(timer);
        visibility.disconnect();
        mutations.disconnect();
      });
    });
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    controllers.forEach((cleanup, host) => {
      if (!event.target.contains(host)) return;
      cleanup();
      controllers.delete(host);
    });
  });
  window.GrowplayReviewCarousel = {init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once: true});
  else init();
})();
